module.exports = __webpack_public_path__ + "images/_/assets/images/popup-close.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup-close.png
// module id = ./src/assets/images/popup-close.png
// module chunks = 1